import React, { useEffect } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
/* eslint-disable max-len */
import './browse.style.scss';

export const BrowseSearchErrorB2C = () => {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('default-4xx.load-plp', {});
    }
  }, []);

  return (
    <div className="sui-max-w-screen-2xl sui-my-0 sui-mx-auto sui-flex sui-flex-wrap sui-flex-auto sui-flex-col">
      <div className="sui-bg-warning-subtle sui-text-center sui-py-16 sm:sui-py-32 md:sui-py-48 lg:sui-py-56">
        <div data-testid="b2c-messaging">
          {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
          <img
            src="https://assets.homedepot-static.com/images/v1/oops.svg"
            className="sui-mx-auto sui-w-11/12 md:sui-w-min"
            alt="error page"
          />
          <h1 className="sui-font-body sui-pt-7 md:sui-pt-5 sui-text-4xl">WE&#39;RE FIXING IT.</h1>
          <div className="sui-text-lg sui-py-5 sui-font-light">
            <p> Your search has found a page that&#39;s not responding.</p>
            <p> We&#39;ll have this patched up as soon as possible. </p>
          </div>
          <Button href="https://www.homedepot.com">
            Back to homepage
          </Button>
        </div>
      </div>
    </div>
  );
};

BrowseSearchErrorB2C.displayName = 'BrowseSearchErrorB2C';